import React, { createContext, useContext, useReducer } from "react";
import _refiner from 'refiner-js';
import { useHistory } from "react-router-dom";

import userReducer, { initialState } from "./userReducer";
import Routes from "../../routes";
import UserInfo from "../../UserInfo";

const UserContext = createContext();

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

export const UserProvider = ({ children }) => {
  const [state, dispatch] = useReducer(userReducer, initialState);
  const history = useHistory();

  const setLoggedIn = (isLoggedIn) => {
    dispatch({
      type: "CHANGE_LOGIN_STATE",
      payload: {
        loggedIn: isLoggedIn,
      },
    });
  };

  const logout = async (url = "/Login", resetPassword = false) => {
    await fetch(Routes.Account.Logout(), {
      method: "POST",
      headers,
    });

    UserInfo.reset();
    _refiner('resetUser');
    setLoggedIn(false);
    localStorage.setItem("logout", String(Date.now()));
    localStorage.removeItem('logout');
    if (resetPassword) {
      return (window.location.href = url);
    }
    history.push(url);
  };

  return (
    <UserContext.Provider
      value={{
        logout,
        setLoggedIn,
        loggedIn: state.loggedIn,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

const useUser = () => {
  return useContext(UserContext);
};

export default useUser;
